export const getFormattedCatchTime = (caughtAtLocalTimeZone: string): string => {
  const caughtAsDateObj = new Date(caughtAtLocalTimeZone);
  return caughtAsDateObj.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};
